<template>
  <div>
    <h2>Contact me</h2>
    <div v-if="status == 2">
      Your message has been sent. Thank you very much.
    </div>
    <div v-else>
      <div class="sf-std-block">
        I always welcome the feedback of teachers. Please let me know if you
        have any problems accessing the content or ideas for improving the
        activities or website.
      </div>
      <div class="tw-flex tw-justify-center">
        <div class="tw-w-full">
          <form @submit.prevent="submit">
            <FormInput v-model="formData.fields.name">
              <label> Name* </label>
              <input
                type="text"
                v-model="formData.fields.name.value"
                class="sf-form-control tw-w-full"
              />
            </FormInput>
            <FormInput v-model="formData.fields.email">
              <label> Email* </label>
              <input
                type="text"
                v-model="formData.fields.email.value"
                class="sf-form-control tw-w-full"
              />
            </FormInput>
            <FormInput v-model="formData.fields.message">
              <label> Message* </label>
              <textarea
                v-model="formData.fields.message.value"
                class="sf-form-control tw-w-full tw-h-24"
              ></textarea>
            </FormInput>
            <div>
              <button type="submit" class="sf-btn-primary">Send message</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import FormInput from "@/components/ui/FormInput.vue";
import submitForm from "@/func/form/submitForm";
import { SfFormData } from "@/types/generalTypes";
import { defineComponent } from "vue";

export default defineComponent({
  components: { FormInput },
  data() {
    return {
      status: 0, // 0 init, 2 success, -1 error
      formData: {
        fields: {
          name: { value: "", required: true },
          email: { value: "", required: true, isEmail: true },
          message: { value: "", required: true },
        },
      } as SfFormData,
    };
  },
  methods: {
    async submit() {
      const resData = await submitForm("contact-message/send", this.formData);
      this.formData = resData.formData;
      if (resData.response.success) {
        this.status = 2;
      } else {
        this.status = -1;
      }
    },
  },
});
</script>
